<script>
  import createAttemptsStore from '../stores/attempts'
  import Score from './Score.svelte'
  import {dateFromString, formatDate} from '../functions-common/date'

  export let projectId;
  export let playerId;
  export let mapId;

  $: attempts = projectId && playerId && mapId ? createAttemptsStore(projectId, playerId, mapId) : null;
  $: isLoading = attempts ? attempts.loading : null;

  $: scores = $attempts
    ? $attempts.map((a, idx) => ({
      ...a,
      rank: idx + 1,
      player_name: formatDate(dateFromString(a.started_at)),
    }))
    : null;
</script>

{#if $isLoading || (scores && scores.length)}
  <section class="nes-container is-rounded with-title">
    {#if !$isLoading}
      {#each scores as score}
        <Score {score}/>
      {/each}
    {:else}
      Loading...
    {/if}
  </section>
{/if}

<style>
    .nes-container {
        margin-top: -.75rem;
        margin-bottom: 1rem;
    }

    @media screen and (max-width: 767px) {
    }
</style>